import { FC, useContext, useEffect, useState } from 'react'
import { GamificationSummaryCon, StreakFire } from './styles'
import { PLLNCareer } from '../../Api'
import { AuthContext } from '../../Api/firebase'
import { Btn } from '../Buttons/Btn'
import { logEvent } from '../../Utils'
import { Spinner } from '../Icons'
import { colors } from '../consts'
import { PLL_IMAGES } from '../../Config/config'
import { Img } from '../Image/Img'
import { ANALYTICS_TAGS } from '../../Constants/analytics'

export const GamificationSummary: FC = () => {
  let { pllNation, login, authLoading } = useContext(AuthContext)!
  const [PLLNSummary, setPLLNSummary] = useState<PLLNCareer | null>(null)
  const [streak, setStreak] = useState<number | null>(null)

  useEffect(() => {
    if (!pllNation?.career) return
    setPLLNSummary(pllNation.career)
    setStreak(pllNation.dailyExpStreak)
  }, [pllNation])

  const onJoinClick = () => {
    logEvent(ANALYTICS_TAGS.join_pll_nation_click, { location: 'gamification_summary' })
    return login()
  }

  if (authLoading)
    return (
      <GamificationSummaryCon>
        <Spinner fill={colors.yellow} width={50} />
      </GamificationSummaryCon>
    )

  return (
    <>
      <GamificationSummaryCon>
        <div className="inner">
          <div className="left">
            <Img src={PLL_IMAGES.pllNationLogo} alt="PLL Nation Logo" />
            <p className="title">
              {PLLNSummary?.fanStatus ? PLLNSummary.fanStatus : `Become a Member`}
            </p>
          </div>
          <div className="right">
            {PLLNSummary && (
              <>
                <p>LVL {PLLNSummary?.level}</p>
                <div className="streakCon">
                  <StreakFire />
                  <p>{streak || 0}</p>
                </div>
              </>
            )}
            {!PLLNSummary && (
              <Btn btnStyle="primary" handleClick={onJoinClick}>
                Join Now
              </Btn>
            )}
          </div>
        </div>
      </GamificationSummaryCon>
    </>
  )
}
